import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ReservaCentralizadaDetalleModalV2 } from '../components/ReservaDetalleModal/interfaces/ReservaCentralizadaDetalleModal'

import { ReservaCentralizadaDetalleModal } from '@/modules/ReservasTemp/interfaces/ReservaCentralizadaDetalleModal'

interface PlanPagosModalState {
  isOpenPlanPagosModal: boolean
  cardsDetail: ReservaCentralizadaDetalleModal | ReservaCentralizadaDetalleModalV2
}

const initialState: PlanPagosModalState = {
  isOpenPlanPagosModal: false,
  cardsDetail: {} as ReservaCentralizadaDetalleModal,
}

const planPagosModalSlice = createSlice({
  name: 'planPagosModal',
  initialState,
  reducers: {
    setIsOpenPlanPagosModal(state, action: PayloadAction<{ value: boolean }>) {
      state.isOpenPlanPagosModal = action.payload.value
    },
    setCardsDetailPlanPagosModal(
      state,
      action: PayloadAction<{ value: ReservaCentralizadaDetalleModal | ReservaCentralizadaDetalleModalV2 }>,
    ) {
      state.cardsDetail = action.payload.value
    },
  },
})

export const { setIsOpenPlanPagosModal, setCardsDetailPlanPagosModal } = planPagosModalSlice.actions

const PlanPagosModalReducer = planPagosModalSlice.reducer

export default PlanPagosModalReducer
